import { hash } from './hash';
import { keys as headerKeys } from './headers';
import { log } from './log';
import { CSRFTimer, JWT } from './keys';
import { request } from './request';
import { timers } from './timers';
import { track as tokenUrl } from './urls';

const expiry = 3e5;

export const tokens = new Map();

export async function csrf(uri = tokenUrl) {
  let result = tokens.get(uri) || '';

  if (result.length === 0) {
    try {
      const res = await request(uri, {
        method: 'HEAD',
        credentials: 'include',
        headers: JWT in sessionStorage ? { [headerKeys.auth]: sessionStorage.getItem(JWT) } : {},
      });

      if (res.ok) {
        result = res.headers.get(headerKeys.csrf) || '';

        if (result.length > 0) {
          const key = `${CSRFTimer}:${hash(uri)}`;

          tokens.set(uri, result);
          log(`Retrieved CSRF token for ${uri}, will expire in 5 minutes`);

          if (timers.has(key)) {
            clearTimeout(timers.get(key));
          }

          timers.set(
            key,
            setTimeout(() => {
              timers.delete(key);
              tokens.delete(uri);
              log(`Expired CSRF token for ${uri}`);
            }, expiry),
          );
        } else {
          log('Failed to retrieve CSRF token; header not found or empty');

          return '';
        }
      } else {
        log('Failed to retrieve CSRF token; server error response');

        return '';
      }
    } catch (err) {
      log('Failed to retrieve CSRF token; something went wrong');

      return '';
    }
  } else {
    log('Reused CSRF token');
  }

  return result;
}
